import React, {useState} from 'react';
import Info from '../../assets/Info.svg';
import styled from 'styled-components';
import {mdDownN} from "../../ui/common";

const ToolTipDiv = styled.div`
    display: ${({showToolTip}) => showToolTip ? 'inline' : 'none'};
    position: absolute;
    top: -48px;
    left: 43px;
    z-index: 999;
    
    .pointerDiv {
        border-top: 15px solid transparent;
        border-left: 10px solid transparent;
        border-right: 20px solid #B3E5FC;
        border-bottom: 15px solid transparent;
        position: absolute;
        top: 41px;
        left: -11px;
    }
    ${mdDownN`
        top: 20px;
        left: 5px;
        .pointerDiv {
            border-top: 20px solid transparent;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-bottom: 15px solid #B3E5FC;
            position: relative;
            // top: 0px;
            // left: 0px;
            top: -5px;
            left: 0px;
        //             top: 41px;
        // left: -11px;
         }
        .contentDiv {
            position: absolute;
            // display: none;
            // font-family: Inter-Regular;
            // font-size: 14px;
            // background: #B3E5FC;
            // min-height: 129px;
            // min-width: 233px;
            // margin-left: 19px;
            // padding: 10px 10px 10px 20px;
            // text-align: left;
            // line-height: 19px;
            top:29px;
            right: -50px;
        }
    `}
    
    .contentDiv {
        font-family: Inter-Regular;
        font-size: 14px;
        background: #B3E5FC;
        min-height: 129px;
        min-width: 233px;
        margin-left: 19px;
        padding: 10px 10px 10px 20px;
        text-align: left;
        line-height: 19px;
    }
    
`;

const MainDiv = styled.div`
    position: relative;
    display: inline;
    
    img {
        position: absolute;
        top: 0;
        left: 10px;
    }
`;


const BalloonTip = (props) => {

    const [showToolTip, updateTooltipState] = useState(false);

    const mouseEnter = () => {
        updateTooltipState(true);
    };

    const mouseLeave = () => {
        updateTooltipState(false);
    };

    return (
        <MainDiv>
            <div className="imageDiv">
                <img src={Info} onMouseEnter={mouseEnter} onClick={mouseEnter} onMouseLeave={mouseLeave}/>
            </div>
            <ToolTipDiv showToolTip={showToolTip}>
                <div className="pointerDiv"></div>
                <div className="contentDiv">
                    {props.children}
                </div>
            </ToolTipDiv>
        </MainDiv>
    );
};

export default BalloonTip;
